import { inject } from '@angular/core';
import { PermissionService } from '../services/permission.service';
import { Router } from '@angular/router';

export const hasViewPermissionGuard = (permissionMainKey:string, navMenuKey: string) => {
    const permissionsService = inject(PermissionService);
    const router = inject(Router);

    if (permissionsService.canRead(permissionMainKey, navMenuKey)) {
        return true;
    } else {
        router.navigate(['/']);
        return false;
    }

};